import { useQuery } from '@apollo/react-hooks';
import { PRODUCT_VERSIONS_QUERY } from 'graphql/queries';
import IProduct, { IVersion } from 'models/product';
import { useCallback, useState } from 'react';

const useLoadProductVersions = (state?: IProduct) => {
  const { error, refetch } = useQuery<{ product: IProduct }>(PRODUCT_VERSIONS_QUERY, {
    skip: true,
    variables: { id: state?.id },
  });

  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [versions, setVersions] = useState<IVersion[]>([]);

  const handleLoad = useCallback(async () => {
    if (!state?.id || loaded) return;

    setLoading(true);

    try {
      const { data } = await refetch();

      const list = (data?.product?.versions || []) as IVersion[];
      setVersions([...list].sort((a, b) => Number(a.createdAt) - Number(b.createdAt)));
      setLoaded(true);
    } finally {
      setLoading(false);
    }
  }, [state?.id, loaded, refetch]);

  return {
    loadingVersions: loading,
    loadedVersions: loaded,
    errorVersions: error,
    versions,
    triggerLoadVersions: handleLoad,
  };
};

export default useLoadProductVersions;
